var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVenue = function SvgVenue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "venue_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.121569 0 0 0 0 0.690196 0 0 0 0 0.968627 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#venue_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 4.667
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 37.333a7 7 0 0 1 7 7v9.334H21v-9.334a7 7 0 0 1 7-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 28v21a4.667 4.667 0 0 1-4.667 4.667H11.667A4.667 4.667 0 0 1 7 49V28"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M15.167 22a6 6 0 0 1-6 6h-.834a6 6 0 0 1-6-6h0v-3.957c0-2.182.765-4.294 2.16-5.971l5.308-6.377a9.333 9.333 0 0 1 7.174-3.362h22.05c2.772 0 5.4 1.232 7.174 3.362l5.308 6.377a9.333 9.333 0 0 1 2.16 5.971V22h0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M28 22a6 6 0 0 1-6 6h-.833a6 6 0 0 1-6-6h0M40.833 22a6 6 0 0 1-6 6H34a6 6 0 0 1-6-6h0M53.667 22a6 6 0 0 1-6 6h-.834a6 6 0 0 1-6-6h0"
  })))));
};
export default SvgVenue;